import { useTranslation } from 'react-i18next';

import { useAtomValue } from 'jotai';
import { ChevronLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { imageIdFromParamsAtom, selectedImageAtom } from '../atoms/imageFiles';
import { EditableImageNameField } from './editable-image-name-field';

interface ImageRenderingHeaderProps {
  imageName?: string;
  estateId?: string;
  onBack: () => void;
  onChangeImageName: (val: string) => Promise<void> | void;
}

export const ImageRenderingHeader = ({
  imageName,
  estateId,
  onBack,
  onChangeImageName,
}: ImageRenderingHeaderProps) => {
  const imageId = useAtomValue(imageIdFromParamsAtom);
  const selectedImage = useAtomValue(selectedImageAtom);
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[58px] items-center bg-primary-lighter px-4 py-1 shadow-lg shadow-black/10 lg:py-6 lg:pl-8 lg:pr-8">
      <div className="flex flex-1 items-center">
        <Button
          size="sm"
          className="h-6 px-1 sm:h-full sm:min-h-[26px] sm:!px-[6px]"
          onClick={onBack}
        >
          <ChevronLeft className="!h-[15px] !w-[15px]" />
        </Button>
        <span className="mx-4 hidden text-base font-semibold text-primary-light sm:block lg:mx-6">
          {t('mediaDatabase')}
        </span>
      </div>
      {imageId || selectedImage ? (
        <div className="flex max-w-[50%] flex-1 justify-center">
          <div className="flex flex-col items-center">
            <span className="text-base text-text-primary">{t('objectName')}</span>
            <EditableImageNameField
              value={imageName ?? ''}
              onChange={onChangeImageName}
              disabled={!estateId}
            />
          </div>
        </div>
      ) : null}
      <div className="flex flex-1" />
    </div>
  );
};
